// import React, { useEffect, useState, useRef } from "react";
// import { Form, Select, Button, message } from "antd";
// import { useDispatch, useSelector } from "react-redux";
// import { getStates } from "../features/statecity/statecitySlice";
// import { getUsers } from "../features/cutomers/customerSlice";
// import { getCollectionInfo } from "../features/invoice/invoiceSlice";
// import { Chart } from "chart.js/auto";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";

// const PaymentCollection = () => {
//   const [chartInstance, setChartInstance] = useState(null);
//   const [activeTable, setActiveTable] = useState("stateWise");
//   const [vcData, setVcData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [selectedState, setSelectedState] = useState("");
//   const [selectedVC, setSelectedVC] = useState("");
//   const [form] = Form.useForm();
//   const chartInstanceRef = useRef(null);
//   const dispatch = useDispatch();

//   const statelistState = useSelector(
//     (state) => state.statecity.statelist || []
//   );
//   const vclistState = useSelector((state) => state.customer.customers || []);
//   const { collectionInfo = { states: [] }, isLoading } = useSelector(
//     (state) => state.invoice || {}
//   );

//   useEffect(() => {
//     dispatch(getStates());
//     dispatch(getUsers());
//     dispatch(getCollectionInfo())
//       .then((response) => {
//         const data = response.payload?.states || [];
//         const filteredData = data
//           .filter((item) => item.state !== null)
//           .map((item) => ({
//             ...item,
//             state: item.state || "WB",
//             vc_name: item.vcUser_id?.name || "BINITA SAHU",
//             invoice_amount: item.totalAmountRaised || 0,
//             amount_received: item.totalReceived || 0,
//             totalInvoiceLastMonth: item.totalInvoiceLastMonth || 0,
//             netPayable: item.netPayable || 0,
//             percentageCollected: item.percentageCollected || 0, // Fetch from API
//           }));
//         setFilteredData(filteredData);
//       })
//       .catch((error) => {
//         console.error("Error fetching collection info:", error);
//         message.error("Failed to load collection data.");
//       });
//   }, [dispatch]);

//   const handleStateChange = (value) => {
//     setSelectedState(value);
//     setSelectedVC("");
//     const filteredVC = vclistState.filter(
//       (customer) => customer.state === value && customer.role === "vc"
//     );
//     setVcData(filteredVC);
//     form.setFieldsValue({ vc_name: undefined });
//   };

//   const handleVcChange = (value) => {
//     setSelectedVC(value);
//   };

//   const handleClear = () => {
//     form.resetFields();
//     setSelectedState("");
//     setSelectedVC("");
//     setVcData([]);
//     dispatch(getCollectionInfo()).then((response) => {
//       const data = response.payload?.states || [];
//       const filteredData = data
//         .filter((item) => item.state !== null)
//         .map((item) => ({
//           ...item,
//           state: item.state || "Unknown",
//           vc_name: item.vcUser_id?.name || "Unknown VC",
//           invoice_amount: item.totalAmountRaised || 0,
//           amount_received: item.totalReceived || 0,
//           totalInvoiceLastMonth: item.totalInvoiceLastMonth || 0,
//           netPayable: item.netPayable || 0,
//           percentageCollected: item.percentageCollected || 0, // Fetch from API
//         }));
//       setFilteredData(filteredData);
//     });
//   };

//   const handleFilterSubmit = (values) => {
//     const filters = {};
//     if (values.state_name) filters.state = values.state_name;
//     if (values.vc_name) filters.vc = values.vc_name;

//     dispatch(getCollectionInfo(filters))
//       .then((response) => {
//         const data = response.payload?.states || [];
//         let filteredData = data
//           .filter((item) => item.state !== null)
//           .map((item) => ({
//             ...item,
//             state: item.state || "Unknown",
//             vc_name: item.vcUser_id?.name || "Unknown VC",
//             invoice_amount: item.totalAmountRaised || 0,
//             amount_received: item.totalReceived || 0,
//             totalInvoiceLastMonth: item.totalInvoiceLastMonth || 0,
//             netPayable: item.netPayable || 0,
//             percentageCollected: item.percentageCollected || 0, // Fetch from API
//           }));

//         if (filters.state) {
//           filteredData = filteredData.filter(
//             (item) => item.state === filters.state
//           );
//         }
//         if (filters.vc) {
//           filteredData = filteredData.filter(
//             (item) =>
//               item.vcUser_id?._id === filters.vc || item.vc === filters.vc
//           );
//         }

//         setFilteredData(filteredData);
//         if (filteredData.length === 0) {
//           message.info("No data matches the selected filters.");
//         }
//       })
//       .catch((error) => {
//         console.error("Filter Error:", error);
//         message.error("Failed to apply filters.");
//       });
//   };

//   const stateWiseLabels = [...new Set(filteredData.map((item) => item.state))];
//   const vcWiseLabels = [...new Set(filteredData.map((item) => item.vc_name))];

//   const stateWiseData = {
//     labels: ["Net Payable", "Amount Received"],
//     datasets: [
//       {
//         data: [
//           stateWiseLabels
//             .map((state) =>
//               filteredData
//                 .filter((item) => item.state === state)
//                 .reduce((sum, item) => sum + item.netPayable, 0)
//             )
//             .reduce((sum, val) => sum + val, 0),
//           stateWiseLabels
//             .map((state) =>
//               filteredData
//                 .filter((item) => item.state === state)
//                 .reduce((sum, item) => sum + item.amount_received, 0)
//             )
//             .reduce((sum, val) => sum + val, 0),
//         ],
//         backgroundColor: ["#ed300e", "#4ade80"],
//       },
//     ],
//   };

//   const vcWiseData = {
//     labels: ["Invoice Amount", "Amount Received"],
//     datasets: [
//       {
//         data: [
//           vcWiseLabels
//             .map((vc) =>
//               filteredData
//                 .filter((item) => item.vc_name === vc)
//                 .reduce((sum, item) => sum + item.invoice_amount, 0)
//             )
//             .reduce((sum, val) => sum + val, 0),
//           vcWiseLabels
//             .map((vc) =>
//               filteredData
//                 .filter((item) => item.vc_name === vc)
//                 .reduce((sum, item) => sum + item.amount_received, 0)
//             )
//             .reduce((sum, val) => sum + val, 0),
//         ],
//         backgroundColor: ["#ed300e", "#4ade80"],
//       },
//     ],
//   };

//   const renderChart = (data) => {
//     if (chartInstance) {
//       chartInstance.destroy();
//     }
//     const ctx = chartInstanceRef.current.getContext("2d");
//     const newChartInstance = new Chart(ctx, {
//       type: "doughnut",
//       data,
//       options: {
//         responsive: true,
//         plugins: {
//           legend: { position: "top" },
//           tooltip: {
//             callbacks: {
//               label: (tooltipItem) => {
//                 return `₹${tooltipItem.raw.toLocaleString()}`;
//               },
//             },
//           },
//         },
//       },
//     });
//     setChartInstance(newChartInstance);
//   };

//   useEffect(() => {
//     if (filteredData.length && chartInstanceRef.current) {
//       renderChart(activeTable === "stateWise" ? stateWiseData : vcWiseData);
//     }
//   }, [filteredData, activeTable]);

//   const handleTableSwitch = (table) => {
//     setActiveTable(table);
//     if (filteredData.length) {
//       renderChart(table === "stateWise" ? stateWiseData : vcWiseData);
//     }
//   };

//   const exportAsPDF = () => {
//     const input = document.getElementById("payment-collection-content");
//     html2canvas(input).then((canvas) => {
//       const imgData = canvas.toDataURL("image/png");
//       const pdf = new jsPDF();
//       pdf.addImage(imgData, "PNG", 0, 0);
//       pdf.save("payment_collection.pdf");
//     });
//   };

//   return (
//     <div
//       id="payment-collection-content"
//       style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}
//     >
//       <div style={{ display: "flex", justifyContent: "space-between" }}>
//         <h4
//           style={{
//             fontSize: "large",
//             fontWeight: "bold",
//             margin: "-20px 0 20px -20px",
//           }}
//         >
//           Payment Collection Targets: State-Wise & VC-Wise
//         </h4>
//         <p
//           style={{
//             textAlign: "right",
//             fontSize: "0.875rem",
//             margin: "-20px 20px 0 0",
//             color: "rgb(107, 114, 128)",
//           }}
//         >
//           Last Updated: {new Date().toLocaleTimeString()}
//         </p>
//       </div>

//       <Form
//         form={form}
//         layout="inline"
//         onFinish={handleFilterSubmit}
//         style={{ marginTop: "20px", marginLeft: "100px" }}
//       >
//         <Form.Item name="state_name">
//           <Select
//             style={{ width: 160 }}
//             placeholder="Select State"
//             onChange={handleStateChange}
//             value={selectedState}
//             allowClear
//           >
//             <Select.Option key="default" value="">
//               Select State
//             </Select.Option>
//             {statelistState.map((i, j) => (
//               <Select.Option key={j} value={i.state}>
//                 {i.state_name}
//               </Select.Option>
//             ))}
//           </Select>
//         </Form.Item>
//         <Form.Item name="vc_name">
//           <Select
//             style={{ width: 160 }}
//             placeholder="Select VC"
//             onChange={handleVcChange}
//             value={selectedVC}
//             allowClear
//             disabled={!selectedState}
//           >
//             <Select.Option key="default" value="">
//               Select VC
//             </Select.Option>
//             {vcData.map((item) => (
//               <Select.Option key={item._id} value={item._id}>
//                 {item.name}
//               </Select.Option>
//             ))}
//           </Select>
//         </Form.Item>
//         <Form.Item>
//           <Button
//             style={{
//               backgroundColor: "#28a745",
//               color: "#fff",
//               marginTop: 16,
//               marginLeft: 135,
//             }}
//             htmlType="submit"
//           >
//             Apply Filter
//           </Button>
//         </Form.Item>
//         <Form.Item>
//           <Button
//             style={{ backgroundColor: "#dc3545", color: "#fff", marginTop: 16 }}
//             onClick={handleClear}
//           >
//             Reset Filter
//           </Button>
//         </Form.Item>
//       </Form>

//       <div
//         style={{
//           backgroundColor: "#ffffff",
//           boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
//           borderRadius: "0.5rem",
//           padding: "1rem",
//           marginTop: "2rem",
//           height: "350px",
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//         }}
//       >
//         {isLoading ? (
//           <p>Loading...</p>
//         ) : filteredData.length > 0 ? (
//           <canvas ref={chartInstanceRef} height="100"></canvas>
//         ) : (
//           <p>No data available</p>
//         )}
//       </div>

//       <div
//         style={{
//           backgroundColor: "#ffffff",
//           boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
//           borderRadius: "0.5rem",
//           padding: "1rem",
//           marginTop: "1rem",
//         }}
//       >
//         <div
//           style={{ display: "flex", justifyContent: "center", gap: "0.5rem" }}
//         >
//           <button
//             onClick={() => handleTableSwitch("stateWise")}
//             style={{
//               flex: 1,
//               textAlign: "center",
//               padding: "0.5rem",
//               border: "none",
//               borderRadius: "0.375rem",
//               fontWeight: "700",
//               backgroundColor:
//                 activeTable === "stateWise" ? "#22c55e" : "#ffffff",
//               color: activeTable === "stateWise" ? "#ffffff" : "#000000",
//               boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
//               cursor: "pointer",
//             }}
//           >
//             State-Wise Collection
//           </button>
//           <button
//             onClick={() => handleTableSwitch("vcWise")}
//             style={{
//               flex: 1,
//               textAlign: "center",
//               padding: "0.5rem",
//               border: "none",
//               borderRadius: "0.375rem",
//               fontWeight: "700",
//               backgroundColor: activeTable === "vcWise" ? "#22c55e" : "#ffffff",
//               color: activeTable === "vcWise" ? "#ffffff" : "#000000",
//               boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
//               cursor: "pointer",
//             }}
//           >
//             VC-Wise Collection
//           </button>
//         </div>
//       </div>

//       {activeTable === "stateWise" ? (
//         <div
//           style={{
//             backgroundColor: "#ffffff",
//             borderRadius: "0.5rem",
//             boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
//             padding: "1rem",
//             marginTop: "0.5rem",
//           }}
//         >
//           <table style={{ width: "100%", borderCollapse: "collapse" }}>
//             <thead>
//               <tr style={{ backgroundColor: "#e5e7eb" }}>
//                 <th style={{ padding: "0.5rem", textAlign: "left" }}>State</th>
//                 <th style={{ padding: "0.5rem", textAlign: "left" }}>
//                   Total Invoice Last Month
//                 </th>
//                 <th style={{ padding: "0.5rem", textAlign: "left" }}>
//                   Net Payable
//                 </th>
//                 <th style={{ padding: "0.5rem", textAlign: "left" }}>
//                   Amount Received
//                 </th>
//                 <th style={{ padding: "0.5rem", textAlign: "left" }}>
//                   % Collected
//                 </th>
//               </tr>
//             </thead>
//             <tbody>
//               {stateWiseLabels.map((state, index) => {
//                 const totalInvoiceLastMonth = filteredData
//                   .filter((item) => item.state === state)
//                   .reduce(
//                     (sum, item) => sum + (item.totalInvoiceLastMonth || 0),
//                     0
//                   );
//                 const netPayable = filteredData
//                   .filter((item) => item.state === state)
//                   .reduce((sum, item) => sum + (item.netPayable || 0), 0);
//                 const actual = filteredData
//                   .filter((item) => item.state === state)
//                   .reduce((sum, item) => sum + (item.amount_received || 0), 0);
//                 const percentageCollected =
//                   filteredData
//                     .filter((item) => item.state === state)
//                     .reduce(
//                       (sum, item) => sum + (item.percentageCollected || 0),
//                       0
//                     ) /
//                     filteredData.filter((item) => item.state === state)
//                       .length || 0;

//                 return (
//                   <tr key={index} style={{ backgroundColor: "#f9fafb" }}>
//                     <td style={{ padding: "0.5rem" }}>{state}</td>
//                     <td style={{ padding: "0.5rem" }}>
//                       ₹{totalInvoiceLastMonth.toLocaleString()}
//                     </td>
//                     <td style={{ padding: "0.5rem" }}>
//                       ₹{netPayable.toLocaleString()}
//                     </td>
//                     <td style={{ padding: "0.5rem" }}>
//                       ₹{actual.toLocaleString()}
//                     </td>
//                     <td style={{ padding: "0.5rem" }}>
//                       {percentageCollected.toFixed(2)}%
//                     </td>
//                   </tr>
//                 );
//               })}
//             </tbody>
//           </table>
//         </div>
//       ) : (
//         <div
//           style={{
//             backgroundColor: "#ffffff",
//             borderRadius: "0.5rem",
//             boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
//             padding: "1rem",
//             marginTop: "0.5rem",
//           }}
//         >
//           <table style={{ width: "100%", borderCollapse: "collapse" }}>
//             <thead>
//               <tr style={{ backgroundColor: "#e5e7eb" }}>
//                 <th style={{ padding: "0.5rem", textAlign: "left" }}>
//                   VC Name
//                 </th>
//                 <th style={{ padding: "0.5rem", textAlign: "left" }}>
//                   Total Invoice Last Month
//                 </th>
//                 <th style={{ padding: "0.5rem", textAlign: "left" }}>
//                   Net Payable
//                 </th>
//                 <th style={{ padding: "0.5rem", textAlign: "left" }}>
//                   Amount Received
//                 </th>
//                 <th style={{ padding: "0.5rem", textAlign: "left" }}>
//                   % Collected
//                 </th>
//               </tr>
//             </thead>
//             <tbody>
//               {vcWiseLabels.map((vc, index) => {
//                 const totalInvoiceLastMonth = filteredData
//                   .filter((item) => item.vc_name === vc)
//                   .reduce(
//                     (sum, item) => sum + (item.totalInvoiceLastMonth || 0),
//                     0
//                   );
//                 const netPayable = filteredData
//                   .filter((item) => item.vc_name === vc)
//                   .reduce((sum, item) => sum + (item.netPayable || 0), 0);
//                 const actual = filteredData
//                   .filter((item) => item.vc_name === vc)
//                   .reduce((sum, item) => sum + (item.amount_received || 0), 0);
//                 const percentageCollected =
//                   filteredData
//                     .filter((item) => item.vc_name === vc)
//                     .reduce(
//                       (sum, item) => sum + (item.percentageCollected || 0),
//                       0
//                     ) /
//                     filteredData.filter((item) => item.vc_name === vc).length ||
//                   0;

//                 return (
//                   <tr key={index} style={{ backgroundColor: "#f9fafb" }}>
//                     <td style={{ padding: "0.5rem" }}>{vc}</td>
//                     <td style={{ padding: "0.5rem" }}>
//                       ₹{totalInvoiceLastMonth.toLocaleString()}
//                     </td>
//                     <td style={{ padding: "0.5rem" }}>
//                       ₹{netPayable.toLocaleString()}
//                     </td>
//                     <td style={{ padding: "0.5rem" }}>
//                       ₹{actual.toLocaleString()}
//                     </td>
//                     <td style={{ padding: "0.5rem" }}>
//                       {percentageCollected.toFixed(2)}%
//                     </td>
//                   </tr>
//                 );
//               })}
//             </tbody>
//           </table>
//         </div>
//       )}
//       <div style={{ marginTop: "20px", display: "flex", gap: "15px" }}>
//         <button
//           style={{
//             ...styles.button,
//             backgroundColor: "#3B82F6",
//             borderRadius: "5px",
//           }}
//           onClick={exportAsPDF}
//         >
//           Export as PDF
//         </button>
//         <button
//           style={{
//             ...styles.button,
//             backgroundColor: "#3B82F6",
//             borderRadius: "5px",
//           }}
//         >
//           Export as CSV
//         </button>
//       </div>
//     </div>
//   );
// };

// const styles = {
//   button: {
//     padding: "8px 12px",
//     color: "#fff",
//     border: "none",
//     cursor: "pointer",
//   },
// };

// export default PaymentCollection;

import React, { useEffect, useState, useRef } from "react";
import { Form, Select, Button, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getStates } from "../features/statecity/statecitySlice";
import { getUsers } from "../features/cutomers/customerSlice";
import {
  getCollectionInfo,
  getCollectionInfoForVc,
} from "../features/invoice/invoiceSlice";
import { Chart } from "chart.js/auto";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const PaymentCollection = () => {
  const [chartInstance, setChartInstance] = useState(null);
  const [activeTable, setActiveTable] = useState("stateWise");
  const [vcData, setVcData] = useState([]);
  const [filteredStateData, setFilteredStateData] = useState([]);
  const [filteredVcData, setFilteredVcData] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [selectedVC, setSelectedVC] = useState("");
  const [form] = Form.useForm();
  const chartInstanceRef = useRef(null);
  const dispatch = useDispatch();

  const statelistState = useSelector(
    (state) => state.statecity.statelist || []
  );
  const vclistState = useSelector((state) => state.customer.customers || []);
  const { collectionInfo = { states: [] }, isLoading } = useSelector(
    (state) => state.invoice || {}
  );

  useEffect(() => {
    dispatch(getStates());
    dispatch(getUsers());

    // Fetch state-wise data
    dispatch(getCollectionInfo())
      .then((response) => {
        const data = response.payload?.states || [];
        const filteredStateData = data
          .filter((item) => item.state !== null)
          .map((item) => ({
            state: item.state || "WB",
            vc_name: item.vcUser_id?.name || "BINITA SAHU",
            totalInvoiceLastMonth: item.totalInvoiceLastMonth || 0,
            totalAmountRaised: item.totalAmountRaised || 0,
            totalReceived: item.totalReceived || 0,
            netPayable: item.netPayable || 0,
            percentageCollected: item.percentageCollected || 0,
          }));
        setFilteredStateData(filteredStateData);
      })
      .catch((error) => {
        console.error("Error fetching state collection info:", error);
        message.error("Failed to load state collection data.");
      });

    // Fetch VC-wise data
    dispatch(getCollectionInfoForVc())
      .then((response) => {
        const data = response.payload?.vcs || [];
        const filteredVcData = data.map((item) => ({
          vc_name: item.vc_name || "Unknown VC",
          totalInvoiceLastMonth: item.totalInvoiceLastMonth || 0,
          totalAmountRaised: item.totalAmountRaised || 0,
          totalReceived: item.totalReceived || 0,
          netPayable: item.netPayable || 0,
          percentageCollected: parseFloat(item.percentageCollected) || 0, // Convert string to number
          completedCount: item.completedCount || 0,
          pendingCount: item.pendingCount || 0,
        }));
        setFilteredVcData(filteredVcData);
      })
      .catch((error) => {
        console.error("Error fetching VC collection info:", error);
        message.error("Failed to load VC collection data.");
      });
  }, [dispatch]);

  const handleStateChange = (value) => {
    setSelectedState(value);
    setSelectedVC("");
    const filteredVC = vclistState.filter(
      (customer) => customer.state === value && customer.role === "vc"
    );
    setVcData(filteredVC);
    form.setFieldsValue({ vc_name: undefined });
  };

  const handleVcChange = (value) => {
    setSelectedVC(value);
  };

  const handleClear = () => {
    form.resetFields();
    setSelectedState("");
    setSelectedVC("");
    setVcData([]);
    dispatch(getCollectionInfo()).then((response) => {
      const data = response.payload?.states || [];
      const filteredStateData = data
        .filter((item) => item.state !== null)
        .map((item) => ({
          state: item.state || "Unknown",
          vc_name: item.vcUser_id?.name || "Unknown VC",
          totalInvoiceLastMonth: item.totalInvoiceLastMonth || 0,
          totalAmountRaised: item.totalAmountRaised || 0,
          totalReceived: item.totalReceived || 0,
          netPayable: item.netPayable || 0,
          percentageCollected: item.percentageCollected || 0,
        }));
      setFilteredStateData(filteredStateData);
    });
    dispatch(getCollectionInfoForVc()).then((response) => {
      const data = response.payload?.vcs || [];
      const filteredVcData = data.map((item) => ({
        vc_name: item.vc_name || "Unknown VC",
        totalInvoiceLastMonth: item.totalInvoiceLastMonth || 0,
        totalAmountRaised: item.totalAmountRaised || 0,
        totalReceived: item.totalReceived || 0,
        netPayable: item.netPayable || 0,
        percentageCollected: parseFloat(item.percentageCollected) || 0,
        completedCount: item.completedCount || 0,
        pendingCount: item.pendingCount || 0,
      }));
      setFilteredVcData(filteredVcData);
    });
  };

  const handleFilterSubmit = (values) => {
    const filters = {};
    if (values.state_name) filters.state = values.state_name;
    if (values.vc_name) filters.vc = values.vc_name;

    // Filter state-wise data
    dispatch(getCollectionInfo(filters))
      .then((response) => {
        const data = response.payload?.states || [];
        let filteredStateData = data
          .filter((item) => item.state !== null)
          .map((item) => ({
            state: item.state || "Unknown",
            vc_name: item.vcUser_id?.name || "Unknown VC",
            totalInvoiceLastMonth: item.totalInvoiceLastMonth || 0,
            totalAmountRaised: item.totalAmountRaised || 0,
            totalReceived: item.totalReceived || 0,
            netPayable: item.netPayable || 0,
            percentageCollected: item.percentageCollected || 0,
          }));

        if (filters.state) {
          filteredStateData = filteredStateData.filter(
            (item) => item.state === filters.state
          );
        }
        setFilteredStateData(filteredStateData);
        if (filteredStateData.length === 0) {
          message.info("No state data matches the selected filters.");
        }
      })
      .catch((error) => {
        console.error("Filter Error (State):", error);
        message.error("Failed to apply state filters.");
      });

    // Filter VC-wise data
    dispatch(getCollectionInfoForVc(filters))
      .then((response) => {
        const data = response.payload?.vcs || [];
        let filteredVcData = data.map((item) => ({
          vc_name: item.vc_name || "Unknown VC",
          totalInvoiceLastMonth: item.totalInvoiceLastMonth || 0,
          totalAmountRaised: item.totalAmountRaised || 0,
          totalReceived: item.totalReceived || 0,
          netPayable: item.netPayable || 0,
          percentageCollected: parseFloat(item.percentageCollected) || 0,
          completedCount: item.completedCount || 0,
          pendingCount: item.pendingCount || 0,
        }));

        if (filters.vc) {
          filteredVcData = filteredVcData.filter(
            (item) =>
              item.vc_name ===
              vclistState.find((vc) => vc._id === filters.vc)?.name
          );
        }
        setFilteredVcData(filteredVcData);
        if (filteredVcData.length === 0) {
          message.info("No VC data matches the selected filters.");
        }
      })
      .catch((error) => {
        console.error("Filter Error (VC):", error);
        message.error("Failed to apply VC filters.");
      });
  };

  const stateWiseLabels = [
    ...new Set(filteredStateData.map((item) => item.state)),
  ];
  const vcWiseLabels = [...new Set(filteredVcData.map((item) => item.vc_name))];

  const stateWiseData = {
    labels: ["Net Payable", "Amount Received"],
    datasets: [
      {
        data: [
          filteredStateData.reduce((sum, item) => sum + item.netPayable, 0),
          filteredStateData.reduce((sum, item) => sum + item.totalReceived, 0),
        ],
        backgroundColor: ["#ed300e", "#4ade80"],
      },
    ],
  };

  const vcWiseData = {
    labels: ["Net Payable", "Amount Received"],
    datasets: [
      {
        data: [
          filteredVcData.reduce((sum, item) => sum + item.netPayable, 0),
          filteredVcData.reduce((sum, item) => sum + item.totalReceived, 0),
        ],
        backgroundColor: ["#ed300e", "#4ade80"],
      },
    ],
  };

  const renderChart = (data) => {
    if (chartInstance) {
      chartInstance.destroy();
    }
    const ctx = chartInstanceRef.current.getContext("2d");
    const newChartInstance = new Chart(ctx, {
      type: "doughnut",
      data,
      options: {
        responsive: true,
        plugins: {
          legend: { position: "top" },
          tooltip: {
            callbacks: {
              label: (tooltipItem) => {
                return `₹${tooltipItem.raw.toLocaleString()}`;
              },
            },
          },
        },
      },
    });
    setChartInstance(newChartInstance);
  };

  useEffect(() => {
    if (chartInstanceRef.current) {
      if (activeTable === "stateWise" && filteredStateData.length) {
        renderChart(stateWiseData);
      } else if (activeTable === "vcWise" && filteredVcData.length) {
        renderChart(vcWiseData);
      }
    }
  }, [filteredStateData, filteredVcData, activeTable]);

  const handleTableSwitch = (table) => {
    setActiveTable(table);
    if (table === "stateWise" && filteredStateData.length) {
      renderChart(stateWiseData);
    } else if (table === "vcWise" && filteredVcData.length) {
      renderChart(vcWiseData);
    }
  };

  const exportAsPDF = () => {
    const input = document.getElementById("payment-collection-content");
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF();
      pdf.addImage(imgData, "PNG", 0, 0);
      pdf.save("payment_collection.pdf");
    });
  };

  return (
    <div
      id="payment-collection-content"
      style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h4
          style={{
            fontSize: "large",
            fontWeight: "bold",
            margin: "-20px 0 20px -20px",
          }}
        >
          Payment Collection Targets: State-Wise & VC-Wise
        </h4>
        <p
          style={{
            textAlign: "right",
            fontSize: "0.875rem",
            margin: "-20px 20px 0 0",
            color: "rgb(107, 114, 128)",
          }}
        >
          Last Updated: {new Date().toLocaleTimeString()}
        </p>
      </div>

      <Form
        form={form}
        layout="inline"
        onFinish={handleFilterSubmit}
        style={{ marginTop: "20px", marginLeft: "100px" }}
      >
        <Form.Item name="state_name">
          <Select
            style={{ width: 160 }}
            placeholder="Select State"
            onChange={handleStateChange}
            value={selectedState}
            allowClear
          >
            <Select.Option key="default" value="">
              Select State
            </Select.Option>
            {statelistState.map((i, j) => (
              <Select.Option key={j} value={i.state}>
                {i.state_name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name="vc_name">
          <Select
            style={{ width: 160 }}
            placeholder="Select VC"
            onChange={handleVcChange}
            value={selectedVC}
            allowClear
            disabled={!selectedState}
          >
            <Select.Option key="default" value="">
              Select VC
            </Select.Option>
            {vcData.map((item) => (
              <Select.Option key={item._id} value={item._id}>
                {item.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item>
          <Button
            style={{
              backgroundColor: "#28a745",
              color: "#fff",
              marginTop: 16,
              marginLeft: 135,
            }}
            htmlType="submit"
          >
            Apply Filter
          </Button>
        </Form.Item>
        <Form.Item>
          <Button
            style={{ backgroundColor: "#dc3545", color: "#fff", marginTop: 16 }}
            onClick={handleClear}
          >
            Reset Filter
          </Button>
        </Form.Item>
      </Form>

      <div
        style={{
          backgroundColor: "#ffffff",
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
          borderRadius: "0.5rem",
          padding: "1rem",
          marginTop: "2rem",
          height: "350px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {isLoading ? (
          <p>Loading...</p>
        ) : activeTable === "stateWise" && filteredStateData.length > 0 ? (
          <canvas ref={chartInstanceRef} height="100"></canvas>
        ) : activeTable === "vcWise" && filteredVcData.length > 0 ? (
          <canvas ref={chartInstanceRef} height="100"></canvas>
        ) : (
          <p>No data available</p>
        )}
      </div>

      <div
        style={{
          backgroundColor: "#ffffff",
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
          borderRadius: "0.5rem",
          padding: "1rem",
          marginTop: "1rem",
        }}
      >
        <div
          style={{ display: "flex", justifyContent: "center", gap: "0.5rem" }}
        >
          <button
            onClick={() => handleTableSwitch("stateWise")}
            style={{
              flex: 1,
              textAlign: "center",
              padding: "0.5rem",
              border: "none",
              borderRadius: "0.375rem",
              fontWeight: "700",
              backgroundColor:
                activeTable === "stateWise" ? "#22c55e" : "#ffffff",
              color: activeTable === "stateWise" ? "#ffffff" : "#000000",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
              cursor: "pointer",
            }}
          >
            State-Wise Collection
          </button>
          <button
            onClick={() => handleTableSwitch("vcWise")}
            style={{
              flex: 1,
              textAlign: "center",
              padding: "0.5rem",
              border: "none",
              borderRadius: "0.375rem",
              fontWeight: "700",
              backgroundColor: activeTable === "vcWise" ? "#22c55e" : "#ffffff",
              color: activeTable === "vcWise" ? "#ffffff" : "#000000",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
              cursor: "pointer",
            }}
          >
            VC-Wise Collection
          </button>
        </div>
      </div>

      {activeTable === "stateWise" ? (
        <div
          className="table-container"
          style={{
            backgroundColor: "#ffffff",
            borderRadius: "0.5rem",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            padding: "1rem",
            marginTop: "0.5rem",
          }}
        >
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ backgroundColor: "#e5e7eb" }}>
                <th style={{ padding: "0.5rem", textAlign: "left" }}>State</th>
                <th style={{ padding: "0.5rem", textAlign: "left" }}>
                  Total Invoice Last Month
                </th>
                <th style={{ padding: "0.5rem", textAlign: "left" }}>
                  Net Payable
                </th>
                <th style={{ padding: "0.5rem", textAlign: "left" }}>
                  Amount Received
                </th>
                <th style={{ padding: "0.5rem", textAlign: "left" }}>
                  % Collected
                </th>
              </tr>
            </thead>
            <tbody>
              {stateWiseLabels.map((state, index) => {
                const stateData =
                  filteredStateData.filter((item) => item.state === state)[0] ||
                  {};
                return (
                  <tr key={index} style={{ backgroundColor: "#f9fafb" }}>
                    <td style={{ padding: "0.5rem" }}>{state}</td>
                    <td style={{ padding: "0.5rem" }}>
                      ₹{stateData.totalInvoiceLastMonth.toLocaleString()}
                    </td>
                    <td style={{ padding: "0.5rem" }}>
                      ₹{stateData.netPayable.toLocaleString()}
                    </td>
                    <td style={{ padding: "0.5rem" }}>
                      ₹{stateData.totalReceived.toLocaleString()}
                    </td>
                    <td style={{ padding: "0.5rem" }}>
                      {parseFloat(stateData.percentageCollected).toFixed(2)}%
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <div
          className="table-container"
          style={{
            backgroundColor: "#ffffff",
            borderRadius: "0.5rem",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            padding: "1rem",
            marginTop: "0.5rem",
          }}
        >
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ backgroundColor: "#e5e7eb" }}>
                <th style={{ padding: "0.5rem", textAlign: "left" }}>
                  VC Name
                </th>
                <th style={{ padding: "0.5rem", textAlign: "left" }}>
                  Total Invoice Last Month
                </th>
                <th style={{ padding: "0.5rem", textAlign: "left" }}>
                  Net Payable
                </th>
                <th style={{ padding: "0.5rem", textAlign: "left" }}>
                  Amount Received
                </th>
                <th style={{ padding: "0.5rem", textAlign: "left" }}>
                  % Collected
                </th>
              </tr>
            </thead>
            <tbody>
              {vcWiseLabels.map((vc, index) => {
                const vcDataItem =
                  filteredVcData.find((item) => item.vc_name === vc) || {};
                return (
                  <tr key={index} style={{ backgroundColor: "#f9fafb" }}>
                    <td style={{ padding: "0.5rem" }}>{vc}</td>
                    <td style={{ padding: "0.5rem" }}>
                      ₹
                      {(vcDataItem.totalInvoiceLastMonth || 0).toLocaleString()}
                    </td>
                    <td style={{ padding: "0.5rem" }}>
                      ₹{(vcDataItem.netPayable || 0).toLocaleString()}
                    </td>
                    <td style={{ padding: "0.5rem" }}>
                      ₹{(vcDataItem.totalReceived || 0).toLocaleString()}
                    </td>
                    <td style={{ padding: "0.5rem" }}>
                      {(vcDataItem.percentageCollected || 0).toFixed(2)}%
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
      <div style={{ marginTop: "20px", display: "flex", gap: "15px" }}>
        <button
          style={{
            ...styles.button,
            backgroundColor: "#3B82F6",
            borderRadius: "5px",
          }}
          onClick={exportAsPDF}
        >
          Export as PDF
        </button>
        <button
          style={{
            ...styles.button,
            backgroundColor: "#3B82F6",
            borderRadius: "5px",
          }}
        >
          Export as CSV
        </button>
      </div>
    </div>
  );
};

const styles = {
  button: {
    padding: "8px 12px",
    color: "#fff",
    border: "none",
    cursor: "pointer",
  },
};

export default PaymentCollection;
